export default __webpack_public_path__ + "static/media/3dIcon.db2cf547.svg";